module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_clubs-jack.74db43a6.svg";